import { mediaQuery } from 'constants/ui';

import { AUS_POPPER_Z_INDEX_OFFSET } from './HeaderViewList.constants';

export const skeletonStyles = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
};

export const containerStyles = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'center',
  gap: '4px',
  minWidth: 0,
};

export const identityRowStyles = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'nowrap',
  columnGap: '12px',
  minWidth: 0,
  overflow: 'hidden',

  [mediaQuery.mobile]: {
    flexWrap: 'wrap',
    rowGap: '6px',
    overflow: 'visible',
  },
};

export const identityItemStyles = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: '8px',
  minWidth: 0,
};

export const identityLoanNumberStyles = {
  color: ({ palette }) => palette.text.secondary,
  whiteSpace: 'nowrap',
  flexShrink: 0,
};

export const identityBorrowerStyles = {
  color: ({ palette }) => palette.text.primary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minWidth: 0,
};

export const identityDividerStyles = {
  height: '16px',
  alignSelf: 'center',
  borderColor: ({ palette }) => palette.border.light,

  // Below the mobile breakpoint the identity row wraps; a fixed-height vertical
  // divider would strand itself at a wrap point, so fall back to gap-only spacing.
  [mediaQuery.mobile]: {
    display: 'none',
  },
};

export const identitySkeletonStyles = {
  borderRadius: '4px',
};

export const metricsRowStyles = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'nowrap',
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',

  [mediaQuery.mobile]: {
    flexWrap: 'wrap',
    overflow: 'visible',
  },
};

export const metricsContainerStyles = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  minWidth: 0,
};

export const itemStyles = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: '6px',
  minWidth: 0,
};

export const ausFieldClickableStyles = {
  cursor: 'pointer',
  borderRadius: '4px',
  padding: '4px',
  margin: '0 -4px',
  '&:hover, &:focus-visible': {
    backgroundColor: ({ palette }) => palette.action.hover,
  },
};

export const itemNameStyles = {
  fontSize: '1.2rem',
  lineHeight: '1.8rem',
  fontWeight: 400,
  color: ({ palette }) => palette.text.secondary,
  whiteSpace: 'nowrap',
};

export const itemValueStyles = noSelectStyles => ({
  fontSize: '1.3rem',
  lineHeight: '1.8rem',
  fontWeight: 700,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  minWidth: 0,

  ...(noSelectStyles ? { userSelect: 'none' } : {}),
});

export const popperStyles = {
  zIndex: ({ zIndex }) => `${zIndex.modal + AUS_POPPER_Z_INDEX_OFFSET} !important`,
  maxWidth: 'calc(100vw - 16px)',
  '& > *': {
    maxWidth: 'calc(100vw - 16px)',
  },
};

export const moreButtonWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
};

export const overflowPopoverContentStyles = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))',
    md: 'repeat(3, minmax(0, 1fr))',
  },
  columnGap: '20px',
  rowGap: '12px',
  maxHeight: '60vh',
  overflowY: 'auto',
  padding: '8px',
  width: 'min(90vw, 720px)',
};

export const detailedSummarySectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  marginTop: '8px',
};

export const detailedSummaryTitleStyles = {
  fontSize: '1.4rem',
  fontWeight: 700,
  color: ({ palette }) => palette.text.primary,
};

export const detailedSummaryGridStyles = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))',
    md: 'repeat(3, minmax(0, 1fr))',
  },
  columnGap: '20px',
  rowGap: '12px',
};

export const popoverDividerStyles = {
  marginTop: '16px',
  marginBottom: '8px',
};

export { measureContainerStyles } from 'hooks/useOverflowCount/constants';
